import "../legal/ComplaintsProcessPage.css";

const ComplaintsProcess = () => {
  return (
    <main className="legal-page">
      <div className="legal-page__container">
        <h1>Complaints Process</h1>
        <p>
          We take complaints seriously and follow a clear internal process to
          resolve concerns fairly and promptly.
        </p>

        <h2>Step-by-Step Process</h2>
        <ol className="complaints-steps">
          <li>
            <h3>Submit your complaint</h3>
            <p>
              Share your concern with us by email or phone. Please include your
              name, contact details, and a brief description of the issue.
            </p>
          </li>
          <li>
            <h3>Internal review</h3>
            <p>
              Our internal team reviews your complaint and may contact you for
              additional information.
            </p>
          </li>
          <li>
            <h3>Response and resolution</h3>
            <p>
              We provide a written response with the outcome and any corrective
              actions or next steps.
            </p>
          </li>
          <li>
            <h3>Escalation option</h3>
            <p>
              If you are not satisfied with the outcome, you may escalate your
              complaint to the Ontario College of Pharmacists.
            </p>
          </li>
        </ol>

        <h2>Contact Details</h2>
        <p>
          Email:{" "}
          <a href="mailto:info@sandyrandhawa.com">info@sandyrandhawa.com</a> or
          call <a href="tel:01900123456">01900 123456</a>.
        </p>

        {/* <h2>Escalation to the Ontario College of Pharmacists</h2>
        <p>
          If your concern remains unresolved, you may submit a complaint to the
          Ontario College of Pharmacists for independent review.
        </p> */}
      </div>
    </main>
  );
};

export default ComplaintsProcess;
